import { render } from "./Controls.vue?vue&type=template&id=fa854f3c&scoped=true"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=fa854f3c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa854f3c"]])

export default __exports__